export default __webpack_public_path__ + "static/media/plc.7c63d607.png";